import {Store} from '../models/store.model';
import {StoreRepository} from '../repository/StoreRepository';

export class CreateStoreUseCase {
  constructor (private storeRepository: StoreRepository) {}

  async execute (store: Store): Promise<Store> {
    return this.storeRepository.create(store);
  }
}
